import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#fff",
        d: "M1 18a.97.97 0 0 1-.713-.288A.96.96 0 0 1 0 17v-.575q0-1.075 1.1-1.75T4 14q.325 0 .625.013.3.014.575.062-.35.525-.525 1.1a4.1 4.1 0 0 0-.175 1.2V18zm6 0a.97.97 0 0 1-.713-.288A.96.96 0 0 1 6 17v-.625q0-.8.438-1.463t1.237-1.162T9.588 13 12 12.75q1.325 0 2.438.25t1.912.75q.8.5 1.225 1.163T18 16.375V17a.97.97 0 0 1-.287.713A.96.96 0 0 1 17 18zm12.5 0v-1.625q0-.65-.163-1.225a4 4 0 0 0-.487-1.075q.275-.05.563-.062T20 14q1.8 0 2.9.663t1.1 1.762V17a.97.97 0 0 1-.288.713A.96.96 0 0 1 23 18zM8.125 16H15.9q-.25-.5-1.388-.875T12 14.75t-2.513.375T8.126 16zM4 13q-.825 0-1.413-.588A1.92 1.92 0 0 1 2 11q0-.85.588-1.425A1.95 1.95 0 0 1 4 9q.85 0 1.425.575T6 11q0 .825-.575 1.413A1.9 1.9 0 0 1 4 13m16 0q-.825 0-1.413-.588A1.92 1.92 0 0 1 18 11q0-.85.588-1.425A1.95 1.95 0 0 1 20 9q.85 0 1.425.575T22 11q0 .825-.575 1.413A1.9 1.9 0 0 1 20 13m-8-1a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 9 9q0-1.275.875-2.138T12 6q1.275 0 2.138.863T15 9q0 1.25-.863 2.125T12 12m0-2a.97.97 0 0 0 .713-.288A.96.96 0 0 0 13 9a.97.97 0 0 0-.288-.713A.96.96 0 0 0 12 8a.97.97 0 0 0-.713.288A.96.96 0 0 0 11 9q0 .425.288.713T12 10"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }